import { ActionItem } from "../../types";
import Compose, { ACTION_LEVEL } from "../Compose";

enum ACTION_ID {
    ITEM = 113
}

export default class Expose extends Compose {
    compose(): ActionItem {
        const { level, item } = this.extraActionItem();

        // 只有物品支持设置行为
        if ([ACTION_LEVEL.ITEM].includes(level) === false) {
            return null;
        }

        item.action_id = ACTION_ID.ITEM;

        try {
            const evtData = this.event["data"];

            const data: { type: number; result: number } =
                typeof evtData === "string" ? JSON.parse(evtData) : evtData;

            item.action_attr = data.type;
            item.action_value = data.result;
        } catch (err) {}

        return item;
    }
}
